import { DataExportActions } from './actions';
import { DataExportActionTypes, DataExportRequestTypes } from './types';
import { combineReducers } from '@fullstory/redux-util/utils';

const freqMinutes = (state: number = 0, action: DataExportActions): number => {
  switch (action.type) {
    case DataExportRequestTypes.GetDataExportSettingsSuccess:
      return action.data.exportFreqMinutes;
    case DataExportActionTypes.UpdateDataExportSettings:
      return action.settings.frequencyMinutes;
    default:
      return state;
  }
};

type DataExportState = {
  freqMinutes: ReturnType<typeof freqMinutes>;
};

export const dataExport = combineReducers<DataExportState>({
  freqMinutes,
});
